import _ from 'lodash';
import React from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useSelector, useDispatch } from 'react-redux';

import { RootState } from '@/src/reducers/types';

import Folders from '../Folders';

const Folder = ({ file, index, draggingData, draggingFromFiles, onToggler, togglers }) => {
  const dispatch = useDispatch();
  const files = useSelector((store: RootState) => store.files);
  const subfolders = file.children || [];
  const name = file.name;

  const onToggle = (e = null) => {
    if (e) e.preventDefault();
    onToggler(togglers.includes(file.id), file.id);
  };

  const handleClickSubfolder = () => {
    onToggle();

    dispatch({ type: 'UPDATE_FILES_SIDEBAR_ACTIVE', menu: { id: 'library', label: 'Library' } });
    dispatch({ type: 'UPDATE_FILES_ACTIVE_FOLDER', folder: { id: file.id, label: name } });
  };

  let isDisabled = draggingData.id === file.id;

  if (draggingFromFiles) {
    isDisabled = isDisabled || files.selectedItems?.some((f) => f.id === file.id);
  }

  return (
    <li className="folderRow">
      <Droppable isDropDisabled={Boolean(isDisabled)} droppableId={`${file.id}`}>
        {(provided, dropSnapshot) => (
          <div
            className={`droppableContainer ${isDisabled ? 'disabled' : ''} ${
              dropSnapshot.draggingOverWith ? 'dropping' : ''
            }`}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            <Draggable
              key={`sidebarColumn_${file.id}`}
              draggableId={`${file.id}`}
              index={index}
              isDragDisabled={true}
            >
              {(provided, snapshot) => (
                <div
                  className={`sidebarDraggable ${
                    files.activeInSidebar.id === 'library' && files.activeFolder.id === file.id
                      ? 'active'
                      : ''
                  }`}
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                >
                  <div className="overlay-anchor"></div>
                  <a
                    id={`collapse-trigger-${file.id}`}
                    className={`accordion-toggle collapsed arrowContainer ${
                      togglers.includes(file.id) ? 'toggled' : ''
                    }`}
                    href={`#collapse-${file.id}`}
                    role="button"
                    onClick={onToggle}
                  >
                    {!!subfolders.length && (
                      <i
                        className={`material-icons arrowIcon ${
                          files.activeFolder.id === file.id ? 'open' : ''
                        }`}
                      />
                    )}
                  </a>
                  <a
                    onClick={handleClickSubfolder}
                    className={`accordion-toggle collapsed link-anchor ${
                      snapshot.draggingOverWith ? 'dragging' : ''
                    }`}
                  >
                    <i className="material-icons">folder</i>
                    {name}
                  </a>
                </div>
              )}
            </Draggable>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      {subfolders.length > 0 && (
        <div
          className={`subfoldersContainer ${togglers.includes(file.id) ? 'toggled' : ''}`}
          id={`collapse-${file.id}`}
        >
          <Folders
            draggingFromFiles={draggingFromFiles}
            draggingData={draggingData}
            folders={subfolders}
            onToggler={onToggler}
            togglers={togglers}
          />
        </div>
      )}
    </li>
  );
};

export default Folder;
